import eventsService from '../../services/eventsService'

class EventsController {
  searchEvents = eventsService.searchEvents
  fetchEventById = eventsService.fetchEventById
  deleteEventById = eventsService.deleteEventById
  fetchAllEventTags = eventsService.fetchAllEventTags
}

export default new EventsController()



// WEBPACK FOOTER //
// ../src/controllers/eventsController/eventsController.js